var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useState } from 'react';
import { CustomerGender } from './types';
import { getTopPicks } from './request';
export function useTopPick4U(_a) {
    var _b = _a.gender, gender = _b === void 0 ? CustomerGender.FEMALE : _b, profileFashionPreference = _a.profileFashionPreference, selectedFashionPreference = _a.selectedFashionPreference;
    var _c = useState(0), retry = _c[0], setRetry = _c[1];
    var _d = useState(false), error = _d[0], setError = _d[1];
    var _e = useState(false), loading = _e[0], setLoading = _e[1];
    var _f = useState([]), topPics4U = _f[0], setTopPics4U = _f[1];
    if (!loading && !topPics4U.length && retry < 2) {
        setLoading(true);
        setRetry(retry + 1);
        getTopPicks(__assign(__assign({ sort: gender }, (profileFashionPreference
            ? { profile_fashion_preference: profileFashionPreference }
            : {})), (selectedFashionPreference
            ? { selected_fashion_preference: selectedFashionPreference }
            : {})))
            .then(function (topPicks) { return setTopPics4U(topPicks || []); })
            .catch(function () {
            setError(true);
        })
            .finally(function () { return setLoading(false); });
    }
    return [topPics4U, loading, error];
}
